















































































































import { Vue, Component } from "vue-property-decorator";
//导入element-ui中form的类型接口
import { Form as ElForm } from "element-ui";
//获取统一身份认证登录参数
import { getLoginParam } from "../../../utils/auth";
//引入vuex中的user模块
import { UserModule } from "../../../store/modules/user";
import { getTeacherCode, getSMS } from "@/api/login"
// 引入sm3哈希算法
import sm3 from 'sm3'

@Component({
  name: "teacher"
})
export default class Login extends Vue {
  private activeName: string = 'pwd';
  private role: string = "school"; //登录的角色
  private teacherLoginForm = {
    loginAccount: "",
    loginPassword: "",
    phoneCode: "",
    key: ""
  };
  private loginRules = {
    loginAccount: [{required: true, message: "请输入账号", trigger: "blur"}],
    loginPassword: [{required: true, message: "请输入密码", trigger: "blur"}],
    phoneCode: [{required: true, message: "请输入验证码", trigger: "blur"}]
  };
  private form = {
    mobile: "",
    verificationCode: "",
  };
  private rules = {
    mobile: [{required: true, message: "请输入手机号码", trigger: "blur"}, {
      pattern: /^1[3456789]\d{9}$/,
      message: '请输入正确的手机号码',
      trigger: 'blur'
    }],
    verificationCode1: [
      {required: true, message: "请输入验证码", trigger: "blur"}],
  };
  private loginLoading: boolean = false;
  private imgUrl = '';
  private manualName: string = '个人注册操作说明.doc';
  private publicPath: string = process.env.BASE_URL;
  private get manualUrl(): string {
    return `${this.publicPath}manual/${this.manualName}`;
  }

  private timer: null | number = null;
  private second = 0;

  created() {
    //进入页面，判断路径中是否有 code，如果有，说明统一身份处于登录状态
    //TODO:正式流程，下面这一行要打开
    // this.commonLoginHandle();
    this.handleCode()
  }

  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  //帐户名不为空，按enter直接光标定位在密码
  private setPasswordFocus() {
    let passwordDom: any = this.$refs['password'];
    if (this.teacherLoginForm['loginAccount'] !== "") passwordDom.focus();
  }

  private setCaptchaFocus() {
    let captchaDom: any = this.$refs['captcha'];
    if (this.teacherLoginForm['loginPassword'] !== "") captchaDom.focus();
  }

  // 获取验证码
  private async handleCode() {
    try {
      let res = await getTeacherCode()
      this.imgUrl = res.data.image
      UserModule.setVerifyCode(res.data.verificationCode)
    } catch (error) {
      this.$message('图片获取失败')
    }
  }

  //点击统一身份认证跳转，如果未登录，则会跳转到统一登录界面；如果已登录，则会携带code，跳回参数中指定的redirectUrl
  private goCommonLogin() {
    let link =
      window.config.loginBaseUrl + "/oauth/authorize?" + getLoginParam();
    window.location.href = link;
  }

  //统一身份认证-登录处理
  private commonLoginHandle() {
    // 获取code
    let code = this.$route.query.code;
    let param = getLoginParam();
    //如果有code，则表示统一身份处于登录状态，下一步是获取Access Token
    if (code) {
      this.setAuthToken(param + "&code=" + code);
    }
  }

  //统一身份认证-获取access token
  private async setAuthToken(postData: any) {
    try {
      //调取UserModule中，获取统一身份认证的 Access Token （token的存储逻辑在 UserModule 中完成）
      await UserModule.GetAccessToken(postData);
    } catch (error) {
      this.$message(error || "登录失败");
    }
  }

  //专家系统自身的教师登录处理
  private loginHandle() {
    //需要声明form的类型，否则找不到validate
    (this.$refs.teacherLoginForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loginLoading = true;
        let params = Object.assign({}, this.teacherLoginForm)
        params['key'] = UserModule.verificationCode
        // 密码加密：仅SM3哈希，不再Base64
        const password = params.loginPassword
        const convertPwd = sm3(password)
        params.loginPassword = convertPwd
        try {
          //调登录的接口，获取token（token的存储逻辑在 UserModule 中完成）
          const data = await UserModule.TeacherLogin(params);

          if (data) {
            this.$router.push({path: "/layout"});
          }
          this.loginLoading = false;
        } catch (error) {
          this.loginLoading = false;
          this.teacherLoginForm.phoneCode = '';
          this.handleCode()
        }
      }
    });
  }

  private async getCode() {
    try {
      const {mobile} = this.form;
      if (!/^1[3456789]\d{9}$/.test(mobile)) {
        this.$message.error("手机号码有误");
        return;
      }

      if (this.second !== 0) {
        return;
      }

      const res = await getSMS({mobile})
      if ((res as any).code === '20000000') {
        this.countdown();
        this.$message.success("发送成功");
      }
    } catch (e) {
    }
  }

  private countdown() {
    if (!this.timer) {
      this.second = 120;
      this.timer = setInterval(() => {
        if (this.second === 0 && this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        } else {
          this.second = this.second - 1;
        }
      }, 1000);
    }
  }

  private loginHandleBySms() {
    //需要声明form的类型，否则找不到validate
    (this.$refs.form as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loginLoading = true;
        const params = Object.assign({}, this.form)
        try {
          //调登录的接口，获取token（token的存储逻辑在 UserModule 中完成）
          const data = await UserModule.TeacherLoginBySms(params);

          if (data) {
            this.$router.push({path: "/layout"});
          }
          this.loginLoading = false;
        } catch (error) {
          this.loginLoading = false;
        }
      }
    });
  }

  private handleClick() {
    this.teacherLoginForm = {
      loginAccount: "",
      loginPassword: "",
      phoneCode: "",
      key: ""
    };
    (this.$refs.teacherLoginForm as any).resetFields();
    this.form = {
      mobile: "",
      verificationCode: "",
    };
    (this.$refs.form as any).resetFields();
    this.second = 0;
    this.timer && clearInterval(this.timer);
  }

  private getToSchool() {
    this.$router.push({path: "/school"});
  }

  private goToRegistered() {
    this.$router.push({path: "/registered"});
  }

}
